import { render, staticRenderFns } from "./ScreensaverStepForm.vue?vue&type=template&id=274fed88&scoped=true"
import script from "./ScreensaverStepForm.vue?vue&type=script&lang=ts"
export * from "./ScreensaverStepForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fed88",
  null
  
)

export default component.exports